//Components
import ItemCart from "../components/Main/ItemCart";

export default function CartPage(){
    return(
        <ItemCart/>
    )
}